import { configureStore } from "@reduxjs/toolkit"
import transcriptionsReducer from "./transcription/index"
import customWordsReducer from "./customWord/index"
import paragraphsReducer from "./paragraph/index"
import headingsReducer from "./heading/index"
import promptsReducer from "./prompt/index"
import tagsReducer from "./tag/index"
import transcriptionTagsReducer from "./transcriptionTag/index"
import undoReducer from "./undo/index"

export const store = configureStore({
    reducer: {
        transcriptions: transcriptionsReducer,
        customWords: customWordsReducer,
        paragraph: paragraphsReducer,
        heading: headingsReducer,
        prompt :promptsReducer,
        tags: tagsReducer,
        transcriptionTags: transcriptionTagsReducer,
        undo: undoReducer
    }
})
